import { makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) => ({
    contrastText: {
        color: theme.palette.getContrastText(theme.palette.primary.main),
    },
}));
